// Where an unemployment period is entered: dates and a reason, nothing else.
//
// None of the federal certifications apply — there was no employer to be
// subject to the FMCSRs at — so none are asked. The end date arrives filled in
// from the period tapped; the start does not, because the driver may only be
// accounting for part of it.

import type { Errors } from '../lib/validation'

import { MonthField } from './MonthField'
import { SectionHeader } from './SectionHeader'

export interface UnemploymentFormProps {
  startMonth: number | null
  endMonth: number | null
  reason: string | null
  onChange: (
    patch: Partial<{
      startMonth: number | null
      endMonth: number | null
      unemploymentReason: string | null
    }>
  ) => void
  errors?: Errors
  maxMonth?: number
}

export const UnemploymentForm = ({
  startMonth,
  endMonth,
  reason,
  onChange,
  errors = {},
  maxMonth,
}: UnemploymentFormProps) => (
  <div className="rounded-[13px] border border-doubleNickel-gray-200 bg-white px-3 py-2.5">
    <SectionHeader title="Details" />
    <div className="mt-2 flex gap-2.5">
      <div className="min-w-0 flex-1">
        <MonthField
          label="Start"
          required
          value={startMonth}
          maxMonth={maxMonth}
          error={errors.startMonth}
          onChange={(value) => onChange({ startMonth: value })}
        />
      </div>
      <div className="min-w-0 flex-1">
        <MonthField
          label="End"
          required
          value={endMonth}
          maxMonth={maxMonth}
          minMonth={startMonth ?? undefined}
          error={errors.endMonth}
          onChange={(value) => onChange({ endMonth: value })}
        />
      </div>
    </div>
    <div className="mt-2.5">
      <div className="mb-0.5 text-[10px] font-medium text-doubleNickel-gray-600">
        Reason
        <span className="ml-0.5 text-doubleNickel-error-600">*</span>
      </div>
      <input
        type="text"
        aria-label="Reason"
        value={reason ?? ''}
        placeholder="Brief explanation"
        onChange={(event) =>
          onChange({ unemploymentReason: event.target.value })
        }
        className="w-full border-b border-doubleNickel-gray-300 bg-transparent py-1 text-[12.5px] text-doubleNickel-gray-900 outline-none placeholder:text-doubleNickel-gray-400"
      />
      {errors.unemploymentReason && (
        <div className="mt-1 text-[10px] text-doubleNickel-error-700">
          {errors.unemploymentReason}
        </div>
      )}
    </div>
  </div>
)
